import type { Bytes } from "@pdfking/tfunc"
import type { VirtualFile } from "../types/files/VirtualFile"
import { FullMethodDispatcher } from "@pdfking/tfunc"
import { VirtualFileType } from "../types/files/VirtualFileType"

export const FileContentSize: (file: VirtualFile) => Bytes =
  FullMethodDispatcher<[VirtualFile], Bytes>({
    [VirtualFileType.GENERATED_FILE]: file => file.size,
    [VirtualFileType.MULTI_PAGE_PDF]: file => FileContentSize(file.content),
    [VirtualFileType.REMOTE_FILE]: () => -1 as Bytes,
    [VirtualFileType.REMOTE_FILE_CHUNK]: file => file.bytes_total,
    [VirtualFileType.SINGLE_PAGE_IMAGE]: file => FileContentSize(file.content),
    [VirtualFileType.SINGLE_PAGE_PDF]: file => FileContentSize(file.content),
    [VirtualFileType.ZIP_FILE]: file => FileContentSize(file.content),
  })
